import { z } from "zod";
import { ModelPricing, AgentRecommendation } from "@fathom/core";

// ── Fetch result wrapper ────────────────────────────────────

export type FetchSource = "remote" | "api" | "local";

export interface FetchResult<T> {
  data: T;
  source: FetchSource;
  stale: boolean;
  fetchedAt: string;
  error?: string;
}

// ── Fetcher options ─────────────────────────────────────────

export interface FetcherOptions {
  offline?: boolean;
  verbose?: boolean;
  timeoutMs?: number;
}

// ── Remote manifest schema ──────────────────────────────────

export const RemoteManifest = z.object({
  version: z.number(),
  updated: z.string(),
  models: z.array(ModelPricing),
  recommendations: z.record(z.string(), AgentRecommendation),
});
export type RemoteManifest = z.infer<typeof RemoteManifest>;

// ── Intelligence suggestion ─────────────────────────────────

export const IntelligenceSuggestion = z.object({
  type: z.enum(["new-model", "price-change", "recommendation-change", "deprecation", "general"]),
  model: z.string().optional(),
  description: z.string(),
  confidence: z.enum(["high", "medium", "low"]),
});
export type IntelligenceSuggestion = z.infer<typeof IntelligenceSuggestion>;

export const IntelligenceResponse = z.object({
  suggestions: z.array(IntelligenceSuggestion),
  summary: z.string(),
});
export type IntelligenceResponse = z.infer<typeof IntelligenceResponse>;
